import { makeStyles } from 'tss-react/mui'
import React from 'react'
import { Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

interface StyleProps {
  size: 'small' | 'medium' | 'large'
  backgroundColor: string
  fontColor: string
  isSelected: boolean
  clickable: boolean
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  cardContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: props.isSelected ? props.fontColor : theme.palette.text.primary,
    borderRadius: theme.shape.borderRadius,
    background: props.isSelected ? props.backgroundColor : theme.palette.grey.grey06,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingLeft: props.size === 'small' ? theme.spacing(1) : theme.spacing(2),
    paddingRight: props.size === 'small' ? theme.spacing(1) : theme.spacing(2),
    minWidth: '80px',
    [`${theme.breakpoints.down('md')} and (orientation: portrait)`]: {
      minWidth: '75%',
    },
    cursor: props.clickable ? 'pointer' : undefined,
    userSelect: 'none',
  },
}))

interface TagProps {
  index: number
  label: string | React.ReactNode
  onClick?: (idx: number) => void
  size: 'small' | 'medium' | 'large'
  color: string
  fontColor?: string
  isSelected: boolean
}

const Tag: React.FC<TagProps> = ({ index, label, onClick, size, color, isSelected, fontColor }) => {
  const { palette } = useTheme()
  const clickable = onClick !== undefined
  const { classes } = useStyles({ size, backgroundColor: color, isSelected, clickable, fontColor: fontColor || palette.text.primary })
  const isCustom = !(typeof label === 'string')

  return (
    <div className={classes.cardContainer} onClick={() => (clickable ? onClick(index) : undefined)}>
      {isCustom && label}
      {!isCustom && <Typography variant={size === 'small' ? 'body2' : 'subtitle2'}>{label}</Typography>}
    </div>
  )
}

export default Tag
